import { useEffect , useState} from 'react';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from "react-router-dom";
import { homeworkActions } from '_store';

import { history } from '_helpers';
import { Modal, Button } from 'react-bootstrap';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';

const localizer = momentLocalizer(moment);
export { HomeWorkMail };

function HomeWorkMail() {
  const dispatch = useDispatch();
  const { homework } = useSelector((x) => x.homework);
  const { classid, token } = useParams();
  const [uniqueHomework, setUniqueHomework] = useState([]);
console.log(homework,'hom');
  useEffect(() => {
    var class_id = classid;
    var date = token;
    dispatch(homeworkActions.getHomeWorkByDate({class_id, date}));

 }, []);
 useEffect(() => {
  if (homework && homework.data) {
    const seenTexts = new Set();
    const filteredHomework = [];

    homework.data.forEach((category) => {
      Object.values(category).forEach((entries) => {
        entries.forEach((entry) => {
          const text = entry.homework_email_text?.trim();
          if (text && !seenTexts.has(text)) {
            seenTexts.add(text);
            filteredHomework.push(entry);
          }
        });
      });
    });

    setUniqueHomework(filteredHomework);
  }
}, [homework]);
    return (

        <div className="grade-table-conatiner">
            <div className='header-title'>
                <h4 className='header-title'>Classroom Homework</h4>
                <h3>Date : {new Date(atob(token)).toISOString().slice(0, 10)}</h3>
            </div>
            <div className="col-lg-12" style={{ textAlign: 'justify', border: '1px solid' }}>
  {homework?.data && homework.data.length > 0 ? (
    homework.data.map((category, index) => {
      const categoryNames = Object.keys(category); // Extract subject names

      return categoryNames.map((categoryName, index1) => {
        // Remove duplicates based on `homework_email_text`
        const uniqueHomework = category[categoryName].filter(
          (item, i, self) =>
            i === self.findIndex((t) => t.homework_email_text === item.homework_email_text)
        );

        return (
          <div key={`${index}-${index1}`} style={{ marginBottom: '20px' }}>
            <h4 style={{ textDecoration: 'underline' }}>{categoryName}</h4> {/* Display Category Name */}
            {uniqueHomework.map((item, index2) => (
              <div key={`${index}-${index1}-${index2}`} style={{ borderBottom: '1px solid gray', padding: '10px 0' }}>
                <p style={{ whiteSpace: 'pre-wrap' }}>{item.homework_email_text}</p>
                <p>
                  <a href="#" target="_blank" style={{ cursor: 'pointer' }}>
                    S1 {item.homework_text} Posted by: {item.Teacher.first_name}
                  </a>
                  <br />
                </p>
              </div>
            ))}
          </div>
        );
      });
    })
  ) : (
    <p>There is no assigned homework on this date.</p>
  )}
</div>


       
      </div>
      
      
    )
}
